import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b3e7aaf0")

_pushScopeId("data-v-b3e7aaf0")
const _hoisted_1 = { class: "shell info-container info-padding" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "info-label-title" }
const _hoisted_5 = { class: "info-label-content" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_7 = { class: "info-title-bottom" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "height20px" }, null, -1)
const _hoisted_9 = { class: "info-title-bottom" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_bread_crumb = _resolveComponent("bread-crumb")
  const _component_list = _resolveComponent("list")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_bread_crumb, {
      headers: _ctx.navHeaders,
      baseLabel: _ctx.$wordList.TabelPersonKeyInHtmlUser,
      basePath: _ctx.basePath
    }, null, 8, ["headers", "baseLabel", "basePath"]),
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.info, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: index > 0 ? 'info-item' : 'info-title-bottom',
          key: item
        }, [
          (index == 0)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode("b", null, _toDisplayString(item.label) + " " + _toDisplayString(item.content), 1)
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("label", _hoisted_4, _toDisplayString(item.label) + ":", 1),
                _createVNode("label", _hoisted_5, _toDisplayString(item.content), 1)
              ]))
        ], 2))
      }), 128)),
      _hoisted_6,
      _createVNode("div", _hoisted_7, [
        _createVNode("b", null, _toDisplayString(_ctx.$wordList.OrderDevice), 1)
      ]),
      _createVNode(_component_list, {
        headers: _ctx.deviceHeaders,
        showCheck: false,
        action: false,
        requestData: _ctx.devRequestData
      }, null, 8, ["headers", "requestData"]),
      _hoisted_8,
      _createVNode("div", _hoisted_9, [
        _createVNode("b", null, _toDisplayString(_ctx.$wordList.OrderApp), 1)
      ]),
      _createVNode(_component_list, {
        headers: _ctx.userHeaders,
        showCheck: false,
        action: false,
        requestData: _ctx.userRequestData
      }, null, 8, ["headers", "requestData"])
    ])
  ]))
})